import { useMemo } from 'react';
import { useUserStore } from '@/store/userStore';
import {
  getAgeGroup,
  getDailyTargets,
  getDayFocus,
  getMealHint,
  getProductHint,
  type AgeGroup,
  type HealthFlags,
} from '@/utils/ageRecommendations';

export function useAgeRecommendations() {
  const { profile } = useUserStore();

  const ageGroup: AgeGroup = useMemo(
    () => getAgeGroup(profile?.birth_date),
    [profile?.birth_date]
  );

  const healthFlags: HealthFlags = (profile as any)?.health_flags ?? {};
  const weightKg = profile?.weight_kg ?? 70;
  const sex = profile?.sex as 'male' | 'female' | null;

  const dailyTargets = useMemo(
    () => getDailyTargets(ageGroup, sex, weightKg),
    [ageGroup, sex, weightKg]
  );

  return {
    ageGroup,
    healthFlags,
    dailyTargets,
    isSeniorFocus: ageGroup === '50+' || ageGroup === '60+' || ageGroup === '70+',
    // Хелперы — оборачиваем чтобы передавать flags автоматически
    getMealHint: (proteinG: number, caloriesKcal: number) =>
      getMealHint({ ageGroup, proteinG, caloriesKcal, healthFlags }),
    getProductHint: (productName: string, proteinG: number, weightG: number) =>
      getProductHint({ ageGroup, productName, proteinG, weightG }),
    getDayFocus: (totalProteinG: number, totalCaloriesKcal: number, targetCaloriesKcal: number) =>
      getDayFocus({
        ageGroup,
        sex,
        weightKg,
        totalProteinG,
        totalCaloriesKcal,
        targetCaloriesKcal,
        healthFlags,
      }),
  };
}
